import { Part, tuning } from "@meleeroyale/sim";

const MAX = [
  tuning.hp.head,
  tuning.hp.torso,
  tuning.hp.upperArm,
  tuning.hp.upperArm,
  tuning.hp.forearm,
  tuning.hp.forearm,
  tuning.hp.thigh,
  tuning.hp.thigh,
  tuning.hp.shin,
  tuning.hp.shin,
];

function colorFor(hp: number, max: number): string {
  if (hp <= 0) return "var(--hp-gone)";
  const r = hp / max;
  if (r > 0.6) return "var(--hp-full)";
  if (r > 0.3) return "var(--hp-mid)";
  return "var(--hp-low)";
}

/** Ten body parts on a 56×96 grid, coloured by remaining HP. */
export function BodySilhouette({ hp, label }: { hp: number[]; label: string }) {
  const c = (part: number) => colorFor(hp[part] ?? 0, MAX[part] ?? 1);
  return (
    <svg viewBox="0 0 56 96" role="img" aria-label={label}>
      <circle cx="28" cy="10" r="8" fill={c(Part.Head)} />
      <rect x="18" y="20" width="20" height="30" rx="4" fill={c(Part.Torso)} />
      <rect x="8" y="21" width="8" height="15" rx="3" fill={c(Part.UpperArmL)} />
      <rect x="40" y="21" width="8" height="15" rx="3" fill={c(Part.UpperArmR)} />
      <rect x="6" y="37" width="8" height="15" rx="3" fill={c(Part.ForearmL)} />
      <rect x="42" y="37" width="8" height="15" rx="3" fill={c(Part.ForearmR)} />
      <rect x="18" y="52" width="9" height="20" rx="3" fill={c(Part.ThighL)} />
      <rect x="29" y="52" width="9" height="20" rx="3" fill={c(Part.ThighR)} />
      <rect x="18" y="73" width="9" height="20" rx="3" fill={c(Part.ShinL)} />
      <rect x="29" y="73" width="9" height="20" rx="3" fill={c(Part.ShinR)} />
    </svg>
  );
}
